import type Signal from "app/pages/sales-intelligence/sub-modules/signals/models/core/Signal";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";
import type NewsSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsSignalFilters";

export const isNewsSignal = (signal: Signal): signal is Signal<NewsSignalFilters> => {
    return signal.signalType === SignalType.News;
};
